const LocationProps = {
    notDeclined: 0,
    declined: 1,
    declinedAndSentToUser: 2,
    UserSentBack: 3,
}
export default LocationProps